import { useStore } from 'vuex';

export default function useStateController() {
  const store = useStore();

  const changeControlHandler = function (actionData) {
    store.dispatch('control/setWidgetAction', actionData);
  };

  return {
    changeControlHandler,
  };
}
